import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MsgboxContent } from "./msgbox-content/msgbox-content.component";
import { MsgBoxService } from "./msgbox.service";
import { ModalModule } from "ngx-bootstrap";
import { LaddaModule } from "angular2-ladda";

@NgModule({
  imports: [CommonModule, LaddaModule, ModalModule.forRoot()],
  declarations: [MsgboxContent],
  entryComponents: [MsgboxContent],
  providers: [MsgBoxService]
})
export class MsgBoxModule {}
